import { getPreviousDate, stringToDate } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { evolutionChartCurrentPeriod, shareOfSearchDetailsEndDate } from "../../@signals"


export const rangeDatesShareOfSearchDetails = [
    {
        label: 'Yesterday',
        value: () => { return [getPreviousDate({ days: 1 }, shareOfSearchDetailsEndDate.value), getPreviousDate({ days: 1 }, shareOfSearchDetailsEndDate.value)] },
        placement: 'left',
        onFocus: () => evolutionChartCurrentPeriod.value = DATE_PERIODS.YESTERDAY
    }, {
        label: 'Last 7 Days',
        value: () => { return [getPreviousDate({ days: 6 }, shareOfSearchDetailsEndDate.value), stringToDate(shareOfSearchDetailsEndDate.value)] },
        placement: 'left',
        onFocus: () => evolutionChartCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS
    }, {
        label: 'Last 30 Days',
        value: () => { return [getPreviousDate({ days: 29 }, shareOfSearchDetailsEndDate.value), stringToDate(shareOfSearchDetailsEndDate.value)] },
        placement: 'left',
        onFocus: () => evolutionChartCurrentPeriod.value = DATE_PERIODS.LAST_30_DAYS
    }, {
        label: 'Last Month',
        value: () => {
            return [
                getPreviousDate({ months: 1 }, new Date(stringToDate(shareOfSearchDetailsEndDate.value).setDate(1))),
                getPreviousDate({ days: 1 },  new Date(stringToDate(shareOfSearchDetailsEndDate.value).setDate(1)))
            ]
        },
        placement: 'left',
        onFocus: () => evolutionChartCurrentPeriod.value = DATE_PERIODS.LAST_MONTH
    }
]